<!-- eslint-disable @angular-eslint/template/no-inline-styles -->
<!-- <div
  #tableViewport
  class="table-viewport"
  [style.overflow]="overflowY"
  [style.maxHeight.vh]="maxHeight"
> -->
<ng-content></ng-content>
<!-- </div> -->
